import Axios from "axios";
import store from "@/store";
import {
  resolveOperatorSupportContext,
  SUPPORT_SCOPE_INTERNAL,
  SUPPORT_SCOPE_PROJECT,
} from "@/utils/supportContext";

function resolveScope(requestedScope) {
  const normalizedScope = String(requestedScope || "").toUpperCase();
  if (
    normalizedScope === SUPPORT_SCOPE_PROJECT ||
    normalizedScope === SUPPORT_SCOPE_INTERNAL
  ) {
    return normalizedScope;
  }
  return resolveOperatorSupportContext(store?.state || {}).escopo;
}

function scopedParams(requestedScope, params = {}) {
  return {
    ...params,
    escopo: resolveScope(requestedScope),
  };
}

class SupportSubjectDataService {
  constructor(requestedScope = null) {
    this.requestedScope = requestedScope;
  }

  getAll() {
    return Axios.get("supportSubjects", {
      params: scopedParams(this.requestedScope),
    });
  }

  getPage(params) {
    return Axios.get("supportSubjects/page", {
      params: scopedParams(this.requestedScope, params),
    });
  }

  create(payload) {
    return Axios.post("supportSubjects", payload, {
      params: scopedParams(this.requestedScope),
    });
  }

  update(payload) {
    return Axios.put(`supportSubjects/${payload.id}`, payload, {
      params: scopedParams(this.requestedScope),
    });
  }

  find(id) {
    return Axios.get(`supportSubjects/${id}`, {
      params: scopedParams(this.requestedScope),
    });
  }

  delete(id) {
    return Axios.delete(`supportSubjects/${id}`, {
      params: scopedParams(this.requestedScope),
    });
  }
}

export function createSupportSubjectDataService(requestedScope = null) {
  return new SupportSubjectDataService(requestedScope);
}

export default new SupportSubjectDataService();
